var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.baseCss, _vm.capLine ? (_vm.baseCss + "-cap-line") : null, 'text-sm'],style:({maxWidth: _vm.width, width: '100%'})},[_c('table-layout',{attrs:{"y-align":_vm.yAlign,"equal-cells":_vm.fixedWidth}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d212c2a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/bcq-ui/components/timeline/timeline.vue
// module id = null
// module chunks = 